import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ICardPoint } from "../../common/models/ICardPoint";
import { ITagValue } from "../../common/models/ITagValue";

export enum ProtocolEnum {
    Cygnet = 0,
    DDE = 1,
    OPC = 2,
    WellLynxXI = 3,
    XSPOC = 4
}


export enum CommandStatusEnum {
    None = -1,
    InProgress = 0,
    Received = 1,       // Specifically for WellLynxXI to indicate the unit received the command
    Sent = 2,           // Specifically for WellLynxXI (per Dan not currently used)
    Success = 3,
    Failed = 4
}

export enum LiveDataCommandEnum {
    Read = 0,
    Write = 1,
    DemandScan = 2,
    Subscribe = 3,
    Unsubscribe = 4,
    GetDynacard = 5,
    GetLiveStrokes = 6,
    UpdateItem = 7,
    Cancel = 8,
    GetPollingStatistics = 9
}

export enum LiveDataCommandStateEnum {
    None = -1,
    EstablishingCommunication = 0,
    InitiatingDemandScan = 1,
    DemandScanInProgress = 2,
    InitiatingWriteDown = 3,
    WriteDownInProgress = 4,
    DemandScanComplete = 5,
    WriteDownComplete = 6,
    DemandScanFailed = 7,
    WriteDownFailed = 8,
    CommunicationFailed = 9,
    InitiatingGetLiveStrokes = 10,
    GetLiveStrokesInProgress = 11,
    GetLiveStrokesComplete = 12,
    GetLiveStrokesFailed = 13,
    CancelingDemandScan = 14,
    CancelingWriteDown = 15,
    InitiatingChangeRegister = 16,
    ChangeRegisterInProgress = 17,
    ChangeRegisterComplete = 18,
    ChangeRegisterFailed = 19,
    InitiatingGetPollingStatistics = 20,
    GetPollingStatisticsInProgress = 21,
    GetPollingStatisticsComplete = 22,
    GetPollingStatisticsFailed = 23



}

export interface ILiveDataStatusModel {
    id: string;
    requestID: string;
    command: LiveDataCommandEnum;
    completedTimestamp: Date;
    deviceStatusList: ILiveDataDeviceStatusModel[];
    cancellationRequestedTimestamp: Date;
}
export interface IPollingStatisticsModel {
    uid: string;

    thisHourPctGoodPolls: number | undefined;
    lastHourPctGoodPolls: number | undefined;
    todayPctGoodPolls: number | undefined;
    yesterdayPCTGoodPolls: number | undefined;
    totalPctGoodPolls: number | undefined;
    secondsSinceComplete: number | undefined;
}

export interface ILiveDataDeviceStatusModel {
    objectID: number;
    objectName: string;
    objectType: eLynxObjectTypeEnum;
    statusComplete: boolean;
    statusItems: ILiveDataStatusItemModel[];
    deviceStatusMessage: string;
    cardPoints: ICardPoint[];
    pollingStatisticItems: IPollingStatisticsModel[]
}

export interface ILiveDataStatusItemModel {
    status: CommandStatusEnum;
    value: ITagValue;
    statusMessage: string;
    tagID: number;
    tagName: string;
    valueValid: boolean;
    
}

export interface ILiveDataStatusInfoModel {
    statusID: string;
    expiresOn: Date;
}
